import { delay } from 'redux-saga';
import { all, call, put, take, takeLatest } from 'redux-saga/effects';
import * as contactsService from "../../services/contacts.service";
import * as actions from '../actions/contacts.actions';
import { loadProfileAction } from '../actions/profile.actions';
import { getProfileId } from "../../services/profile.service";
import { toaster } from '../../components/Toasts/toaster';

const CONTACTS_FETCH_DELAY = 30000;

export function* loadContactsSaga(action) {
  try {
    yield put({ type: `${actions.LOAD_CONTACTS}_PENDING` });
    const result = yield call(
      contactsService.getContacts,
      action.payload ? action.payload.profileId : null
    );
    yield put({ type: `${actions.LOAD_CONTACTS}_SUCCEEDED`, payload: result });
  } catch (error) {
    yield put({ type: `${actions.LOAD_CONTACTS}_FAILED`, payload: error });
  }
}

export function* loadContactCardSaga(action) {
  try {
    const { slug } = action.payload;
    yield put({ type: `${actions.LOAD_CONTACT_CARD}_PENDING` });
    const result = yield call(contactsService.getContactCard, slug);
    const profileId = result.data.data.id;
    yield put({ type: `${actions.LOAD_CONTACT_CARD}_SUCCEEDED`, payload: result.data });
    yield put({ type: actions.LOAD_CONTACTS, payload: { profileId } })
  } catch (error) {
    yield put({ type: `${actions.LOAD_CONTACT_CARD}_FAILED`, payload: error });
  }
}

export function* addContactSaga(action) {
  try {
    const { targetId } = action.payload;
    const payload = {
      creator: getProfileId(),
      target: targetId,
    };
    yield put({ type: `${actions.ADD_CONTACT}_PENDING` });
    const result = yield call(contactsService.createContactInvite, payload);

    yield put({ type: `${actions.ADD_CONTACT}_SUCCEEDED`, payload: result });
    yield call(toaster, 'contactRequestSent');

    yield put({ type: actions.LOAD_CONTACTS });
  } catch (error) {
    yield put({ type: `${actions.ADD_CONTACT}_FAILED`, payload: error });
  }
}

export function* deleteContactSaga(action) {
  try {
    const payload = {
      profile_id: getProfileId(),
      contact_id: action.payload.contactId,
    };
    yield put({ type: `${actions.DELETE_CONTACT}_PENDING` });
    yield call(contactsService.deleteContact, payload);
    yield put({ type: `${actions.DELETE_CONTACT}_SUCCEEDED` });
    yield put(loadProfileAction());
  } catch (error) {
    yield put({ type: `${actions.DELETE_CONTACT}_FAILED`, payload: error });
  }
}

export function* updateContactInviteSaga(action) {
  try {
    yield put({ type: `${actions.UPDATE_CONTACT_INVITE}_PENDING` });
    yield call(contactsService.updateContactInvite, action.payload);
    yield put({ type: `${actions.UPDATE_CONTACT_INVITE}_SUCCEEDED` });
    yield call(toaster, `contact${action.payload.status}`);
    yield put({ type: actions.LOAD_CONTACT_INVITES });
    yield put(loadProfileAction());
  } catch (error) {
    yield put({ type: `${actions.UPDATE_CONTACT_INVITE}_FAILED`, payload: error });
  }
}

export function* loadContactInvitesSaga() {
  try {
    yield put({ type: `${actions.LOAD_CONTACT_INVITES}_PENDING` });
    const result = yield call(contactsService.getContactInvites, getProfileId());
    yield put({ type: `${actions.LOAD_CONTACT_INVITES}_SUCCEEDED`, payload: result });
    yield call(delay, CONTACTS_FETCH_DELAY);
    yield put(actions.loadContactInvitesAction());
  } catch (error) {
    yield put({ type: `${actions.LOAD_CONTACT_INVITES}_FAILED`, payload: error });
    yield call(delay, CONTACTS_FETCH_DELAY);
    yield put(actions.loadContactInvitesAction());
  }
}

// export function* watchLoadContactsSaga() {
//   yield takeLatest(actions.LOAD_CONTACTS, loadContactsSaga);
// }

export function* watchLoadContactCardSaga() {
  yield takeLatest(actions.LOAD_CONTACT_CARD, loadContactCardSaga);
}

export function* watchAddContactSaga() {
  yield takeLatest(actions.ADD_CONTACT, addContactSaga);
}

export function* watchDeleteContactSaga() {
  yield takeLatest(actions.DELETE_CONTACT, deleteContactSaga);
}

export function* watchLoadContactInvitesSaga() {
  yield takeLatest(actions.LOAD_CONTACT_INVITES, loadContactInvitesSaga);
}

export function* watchUpdateContactInviteSaga() {
  yield takeLatest(actions.UPDATE_CONTACT_INVITE, updateContactInviteSaga);
}

export default function* contactsSagas() {
  yield all([
    // watchLoadContactsSaga(),
    watchLoadContactCardSaga(),
    watchAddContactSaga(),
    watchDeleteContactSaga(),
    watchLoadContactInvitesSaga(),
    watchUpdateContactInviteSaga(),
  ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagas/contacts.sagas.js